<template>
  <div class="reports-main" :style="{ backgroundColor: $store.state['backgroundColor'] }">
    <div class="left-section" :style="{ display: sections.length == 0 ? 'none' : 'flex' }">
      <!-- <div class="title">{{ title }}</div> -->
      <div class="left-container">
        <!-- <div class="section-container" v-for="(s, i) in sections" :key="i" :style="{ height: s['show'] ? '100%' : 'max-content' }"> -->
        <div class="section-container" v-for="(s, i) in sections" :key="i" :style="getContainerStyling(i)">
          <button @click="s['show'] = !s['show']" :disabled="s['child'].length == 0">
            <div>{{ s['name'] }}</div>
            <img src="https://dsmlib.logistics.systems/Icons/Sort.png" :style="{ transform: `scaleY(${s['show'] ? -1 : 1})`, opacity: `${s['child'].length == 0 ? 0.3 : 1}` }">
          </button>
          <div class="section-child" :class="{ 'section-hide': !s['show'] }">
            <div v-for="(c, ic) in s['child']" :key="ic" class="info-block">
              <div class="title">{{ c }}</div>
              <slot :name="`${s['name']}_${c}`"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-section" :style="{ width: sections.length == 0 ? '100%' : '60%' }">
      <div class="title">{{ title }}</div>
      <div class="top-bar">
        <Input textAlign="center" :placeholder="placeholder" :inputValue.sync="topInput" :isDisabled="inputDisabled" />
        <button @click="createReport" style="margin-left:5px;"><img src="https://dsmlib.logistics.systems/Icons/RefreshOutline.png"> Preview Report</button>
        <button v-if="jsReport" @click="printReport" :disabled="!pdfBlob" style="margin-left:5px;">
          <img src="https://dsmlib.logistics.systems/Icons/Print.png" :style="{ opacity: !pdfBlob ? 0.3 : 1 }"> Print
        </button>
        <button v-if="jsReport" @click="shareClicked" :disabled="!pdfBlob" style="margin-left:5px;">
          <img src="https://dsmlib.logistics.systems/Icons/ShareOutline.png" :style="{ opacity: !pdfBlob ? 0.3 : 1 }"> Share
        </button>
        <div class="pdf-loading">{{ pdfLoading }}</div>
      </div>
      <iframe v-if="jsReport" frameborder="0" :src="pdfLink" ref="pdfFrame"></iframe>
      <DesignerV3 v-else-if="designerV3" :reportFiles="designerV3ReportFiles" :reportFolders="designerV3ReportFolders" :reportData="designerV3ReportData"
        :sharedData="designerV3SharedData" :downloadName="reportDownloadName" :backgroundImageFiles="designerV3BackgroundFiles"
        :backgroundImageFolders="designerV3BackgroundFolders" :canShare="true" :shareContent="designerV3ShareBehaviour" :canClose="false" 
        @printClicked="designerV3PrintClicked" @afterPrint="designerV3AfterPrint" />
      <DesignerV2 v-else-if="designerV2" :viewMode="true" :reportFolder="designerV2ReportFolder || 'ROTForm'" :reportFile="designerV2ReportFile"
        :reportData="designerV2Data" :canShare="true" :canClose="false" />
      <Designer v-else :quickPrint="true" :form="rdForm" :data="rdData" />
      <!-- <Pager v-else mode="P" :form="rdForm" :data="rdData" /> -->
    </div>

    <div v-if="showSharePopup" class="share-selection">
      <div class="share-popup-title" style="padding:10px;">
        <img src="https://dsmlib.logistics.systems/Icons/Share.png"/><br />
        Share
      </div>
      <div class="share-popup-container">
        <button @click="mediaShare('mail')" style="background:#505050;color:#FFFFFF;margin:5px;width:115px;"><img src="https://dsmlib.logistics.systems/Icons/WhiteMail.png"/> Email</button>
        <button @click="mediaShare('whatsapp')" style="background:#25D366;color:#FFFFFF;margin:5px;width:115px;"><img src="https://dsmlib.logistics.systems/Icons/WhiteWhatsapp.png"/> WhatsApp</button>
        <button @click="mediaShare('tele')" style="background:#0088cc;color:#FFFFFF;margin:5px;width:115px;"><img src="https://dsmlib.logistics.systems/Icons/Telegram.png"/> Telegram</button>
        <div class="share-copy">
          <input type="text" :value="fileLink" ref="copyBookingConfirmation" class="share-copy-holder">
          <button @click="copyLink"><img src="https://dsmlib.logistics.systems/Icons/Copy.png"/></button>
        </div>
        <div v-if="linkCopied">
          Copied to Clipboard
        </div>
        <div class="share-cancel"> 
          <button @click="showSharePopup = false" style="margin:5px;">Cancel</button>
        </div>
      </div>
    </div>

    <div class="version-in-report-page">
			<img :src="logo" alt="" height="20" @click="convertStyling">
			<div>v{{ $store.state['versions'].length > 0 ? $store.state['versions'][0]['Version'] : ''  }}</div>
		</div>
  </div>
</template>

<script>
/* eslint-disable */
import Designer from '@/components/reportDesigner/Designer.vue';
import axios from 'axios';

export default {
  components: {
    Designer
  },
  data: function() {
    return {
			logo: '',
			version: '',

      // showInfo: true,
      // showFilter: true,

      topInput: '',

      pdfBlob: null,
      pdfLink: '',
      fileLink: '',
      pdfLoading: '',

      showSharePopup: false,
      linkCopied: false,

      rdForm: '',
      rdData: null,
    }
  },
  props: {
    title: { type: String, default: 'Use title props' }, // The title that is showed at the top in the right side
    placeholder: { type: String, default: 'Use placeholder props' }, // The placeholder of the top right input
    inputValue: { type: String, default: '' }, // The value of the top right input
    inputDisabled: { type: Boolean, default: false }, // Set true to disable to the top right input

    jsReport: { type: Boolean, default: true }, // Set to false if using Report Designer
    designerV2: { type: Boolean, default: false },
    designerV3: { type: Boolean, default: false },
    reportDesignerForm: { type: String, default: '' }, // The form name of the report designer
    reportDesignerData: { type: Object, default: function() { return {} } }, // The data that is passed to the report designer

    designerV2ReportFolder: { type: String, default: '' },
    designerV2ReportFile: { type: Array, default: function() { return [] } },
    designerV2Data: { type: Object, default: function() { return null } },

    designerV3ReportFiles: { type: Array, default: function() { return null; } },
    designerV3ReportFolders: { type: Array, default: function() { return null; } },
    designerV3ReportData: { type: Array, default: function() { return null; } },
    designerV3SharedData: { type: Object, default: function() { return null; } },
    designerV3BackgroundFiles: { type: Array, default: function() { return null; }},
    designerV3BackgroundFolders: { type: Array, default: function() { return null; }},
    designerV3ShareBehaviour: { type: Object, default: function() {
      return {
        behaviour: "uploadAndPopup",
        options: {
          fileName: "",
          folder: "",

          body: `Your report is available at: {link}`,
          subject: 'Report'
        },
      };
    } },

    reportDownloadName: { type: String, default: "Report" },
    shareContent: { type: Object, default: function() {
      return {
        body: `Your report is available at: {link}`,
        subject: 'Report'
      }
    } }, // The body and subject of how your content will be shared, use '{link}' to include the link to the pdf file, use '%0D%0A' for carriage return / next line
    sections: { type: Array, default: function() { return [] } }, // The left sections of the report page, see example below
    // Sample of sections props
    // {
    //   name: 'Doc info', // title for the collapsible section
    //   child: [ 'Header', 'Footer', ], // title for each of the child in the collapsible section
    //   show: true // default to expand or collapse
    // }
    // The slot name in your implementation page should be `{name}_{child}` example for above is `Doc info_Header` && `Doc info_Footer`
    // Leave the sections as empty array if your want to hide the left section
    // Leave the child as empty array and show to false if you want to disable the child

    // PUBLIC EVENTS
    // @generateReport - Fired when the 'Preview Report' button is clicked
    // @shareReport - Fired when the 'Share' button is clicked
  },
  methods: {
    shareClicked: function() {
      this.showSharePopup = true;
      this.$emit('shareReport');
    },
    createReport: function() {
      this.$emit('generateReport');
    },
    copyLink: function() {
      let inputToCopy = this.$refs['copyBookingConfirmation'];
      inputToCopy.select();
      inputToCopy.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(inputToCopy.value);
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 1000);
    },
    getContainerStyling: function(index) {
      let openedSections = this.sections.map((s, i) => s['show'] ? i : '-1').filter(s => s > -1);
      let closedSections = this.sections.map((s, i) => !s['show'] ? i : '-1').filter(s => s > -1);

      if (openedSections.length == 0) {
        return { height: 'max-content' };
      } else if (closedSections.length == 0) {
        if (this.sections.length > 2) {
          return { height: `calc(${100 / openedSections.length}%)` };
        } else {
          return { height: `calc(${100 / openedSections.length}%)` };
        }
      } else {
        if (closedSections.includes(index)) {
          return { height: 'max-content' };
        } else {
          let perc = 100 / openedSections.length;
          let closedHeight = closedSections.length * 33 / openedSections.length;
          if (this.sections.length > 2) {
            return { height: `calc(${perc}% - ${closedHeight}px)` };
          } else {
            return { height: `calc(${perc}% - 33px)` };
            // return { height: `calc(${100 / openedSections.length}%)` };
          }
        }
      }
    },
    mediaShare: function(app) {
      let url = '';
      let subject = encodeURIComponent(this.shareContent['subject']);
      let body = encodeURIComponent(this.shareContent['body'].split('{link}').join(this.fileLink));

      switch (app) {
        case 'mail':
          url = `mailto:?subject=${subject}&body=${body}`;
          break;
        case 'whatsapp':
          url = `https://wa.me/?text=${body}`;
          break;
        case 'tele':
          url = `https://t.me/share/url?url=${body}`;
          break;
      }

      window.open(url, '_blank');
    },

    convertStyling: async function() {
      let text = await navigator.clipboard.readText();
      text = text.split(' ').join('').split('\r\n').join('');
      console.log(text);
      
      let result = [];
      let allDeclarations = text.split(';').filter(a => a);
      allDeclarations.forEach(a => {
        let key = a.split(':')[0];
        let val = a.split(':')[1];
        
        if (val.includes('px')) {
          result.push('\'' + key + '\': `${' + parseInt(val) + ' * zoomLevel}px`,');
        } else {
          result.push(`'${key}': '${val}',`);
        }
      })
      
      await navigator.clipboard.writeText(result.join('\n\t\t\t'));
      this.$bus.$emit('receivedNoti', {
        from: 'Clipboard',
        text: 'Done',
        timeout: 1000,
      });
    },

    designerV3PrintClicked: function() {
      this.$emit("printClicked");
    },
    designerV3AfterPrint: function() {
      this.$emit("afterPrint");
    },

    // PUBLIC METHODS
    generateReport: async function(reportID, reportData) { // Public method to generate the report (For JSReport)
      this.pdfLink = '';
      this.pdfLoading = 'Loading Report . . .';

      let data = {
        template: { shortid: reportID },
        data: reportData,
        options: { 'Content-Disposition': 'attachment;filename=report.pdf'}
      };
      let headerInfo = {
        'Content-Type': 'application/json',
        'Authorization': 'Basic YWRtaW46ZG1fNTU2OWRz'
      };
      try {
        let jsReportPDF = await axios.post('https://dsm.logistics.systems:5488/api/report', data, { headers: headerInfo, responseType: 'arraybuffer' });
        let contentType = jsReportPDF.headers['content-type'];
        let pdfBlob = new Blob([ jsReportPDF.data ], { type: contentType });
        var url = window.URL.createObjectURL(pdfBlob, { oneTimeOnly: false });
        var link = document.createElement('a');
        link.href = url;
        this.pdfLink = url;
        this.pdfBlob = pdfBlob;

        this.pdfLoading = '';
      } catch(e) {
        this.pdfLoading = 'Error loading report, please try again';
        console.log(e);
      }
    },
    generateReportDesigner: async function(form, data) { // Public method to generate the report (For Report Designer)
      this.rdForm = form;
      this.rdData = data;
    },
    printReport: function() { // Public and private method used to print the report
      if (this.pdfLink) {
        let frame = this.$refs['pdfFrame'].contentWindow;
        frame.focus();
        frame.print();
      }
    },
    generateShareLink: async function(fileName, folder, shareContent) { // Public method to generate the share link
      if (this.pdfBlob) {
        var formData = new FormData();
        formData.append('file', this.pdfBlob, `${fileName}.pdf`);
        formData.append('folder', folder);
        
        var bookingConfirmationLink = await this.$apiCallV2('/Upload/UploadFile', formData);
        if (bookingConfirmationLink['Files'].length > 0) {
          this.fileLink = bookingConfirmationLink['Files'][0];
          if (shareContent) {
            if (shareContent['body']) {
              this.shareContent['body'] = shareContent['body'];
            }
            if (shareContent['subject']) {
              this.shareContent['subject'] = shareContent['subject'];
            }
          }
        }
        else {
          this.fileLink = "Error Generating Link";
        }
      }
    }
  },
  async mounted() {
		let userDetails = await this.$apiCallV2('/Login/GetDetails');
		this.logo = userDetails['CoLogo'];

    if (this.inputValue) {
      this.topInput = this.inputValue;
    }

    if (this.reportDesignerForm) { this.rdForm = this.reportDesignerForm }
    if (this.reportDesignerData) { this.rdData = this.reportDesignerData }
  },
  watch: {
    topInput: function(val) {
      this.$emit('update:inputValue', val);
    },
    inputValue: function(val) {
      this.topInput = val;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.reports-main {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  height: 100%;
  width: 100%;
  font-size: 12px;

  > .left-section, .right-section {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  > .left-section {
    width: 40%;
    border-radius: 5px;
    background-color: white;
    padding: 5px;
    margin-right: 5px;
    padding-top: 30px;

    > .title {
      font-weight: bold;
    }

    > .left-container {
      // background-color: red;
      height: 100%;
      width: 100%;

      > .section-container {
        height: 100%;
        display: flex;
        flex-direction: column;

        > button {
          margin-top: 5px;
          position: relative;
          width: 100%;
    
          > img {
            transition: 0.3s;
            position: absolute;
            right: 5px;
            top: 0;
            height: 100%;
            width: 15px;
            object-fit: contain;
          }
        }

        > .section-child {
          border-width: 0 1px 1px 1px;
          border-style: solid;
          border-color: rgba(0,0,0,0.3);
          height: 100%;
          padding: 5px;
          overflow: auto;

          > .info-block {
            border: 1px solid rgba(0,0,0,0.75);
            border-radius: 3px;
            padding: 5px;
            padding-top: 15px;
            margin-top: 15px;
            margin-bottom: 5px;
            position: relative;
            
            > .title {
              background-color: white;
              width: fit-content;
              padding: 0 10px;
              position: absolute;
              top: -10px;
              left: 10px;
            }
          }
        }

        > .section-hide {
          max-height: 0;
          padding: 0;
          overflow: hidden;
          border: none;
        }
      }
    }
  }

  > .right-section {
    width: 60%;

    > .title {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      margin-bottom: 5px;
      background-color: white;
      text-align: center;
      font-weight: bold;
    }

    > .top-bar {
      display: flex;
      align-items: center;
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      margin-bottom: 5px;
      position: relative;

      > button {
        white-space: nowrap;

        > img {
          height: 20px;
        }
      }

      > .pdf-loading {
        position: absolute;
        width: 100%;
        text-align: center;
        top: calc(100% + 10px);
        pointer-events: none;
      }
    }

    > iframe {
      background-color: white;
      border-radius: 5px;
      height: 100%;
    }
  }

  .version-in-report-page {
    position: fixed;
    top: 5px;
    left: 5px;
    background-color: white;
    padding: 5px;
    font-size: 12px;
    border-radius: 5px;
    display: flex;
    align-items: center;

    > img {
      margin-right: 5px;
    }
  }
}

.share-selection {
  position: fixed;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 999;

  > .share-popup-container {
    background-color: white;
    width: 100%;
    max-width: 30%;
    max-height: 60%;
    padding: 10px;
    overflow: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > button > img {
      height: 20px;
    }

    > .share-copy {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
      padding-top: 10px;
      
      > .share-copy-holder {
        width: 100%;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom: 1px solid rgb(200,200,200);
      }

      > button > img {
        height: 20px;
      }
    }

    > .share-cancel {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  > .share-popup-title {
    width: 100%;
    max-width: 30%;
    background-color: white;
    padding: 10px 0;
    text-align: center;
    font-weight: bold;
    font-size: 14px;

    > img {
      height: 90px;
    }
  }
}
</style>